import { render, staticRenderFns } from "./contactdetailinfo.vue?vue&type=template&id=fe65c9e6&scoped=true&"
import script from "./contactdetailinfo.vue?vue&type=script&lang=ts&"
export * from "./contactdetailinfo.vue?vue&type=script&lang=ts&"
import style0 from "./contactdetailinfo.vue?vue&type=style&index=0&id=fe65c9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe65c9e6",
  null
  
)

export default component.exports